import { ConfigProvider } from "antd";
import esES from "antd/lib/locale/es_ES";
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { AffiliateProfileProvider } from "./afiliadoContext";
import App from "./App";
import ThemeContext from "./context/ThemeContext";
import { CompanyProfileProvider } from "./CustomContext";
import { store } from "./store/store";

const root = ReactDOM.createRoot(document.getElementById("root"));

const isAffiliate = window.location.pathname.includes("/afiliado");

root.render(
  <React.StrictMode>
    {isAffiliate ? (
      <AffiliateProfileProvider>
        <ConfigProvider locale={esES}>
          <Provider store={store}>
            <BrowserRouter basename="/boletadigital">
              <ThemeContext>
                <App />
              </ThemeContext>
            </BrowserRouter>
          </Provider>
        </ConfigProvider>
      </AffiliateProfileProvider>
    ) : (
      <CompanyProfileProvider>
        <ConfigProvider locale={esES}>
          <Provider store={store}>
            <BrowserRouter basename="/boletadigital">
              <ThemeContext>
                <App />
              </ThemeContext>
            </BrowserRouter>
          </Provider>
        </ConfigProvider>
      </CompanyProfileProvider>
    )}
  </React.StrictMode>
);
